<template>
    <div>
        <Topbar title="Sadakhata" keymap={true} />
        <Main>
            <div class="jumbotron">
                <div class="container">
                    <div class="page-header">
                        <h1>
                            Sadakhata <small>Phonetic Bangla Converter</small>
                        </h1>
                    </div>
                    <p>
                        Colour the virtual life with Bengali language and tell the whole world how adorable the Bengali language is! Lots of love to the martyr's of our language movement.
                    </p>
                </div>
            </div>
            <div class="container">
                <p class="lead">
                    Sadakhata Phonetic Bangla Converter is an app which you can use from any mobile / iPad / computer / MacBook. It is an online-based converter, so to use it you will need an internet connection. Choose your favorite version from the list on left sidebar. Then write following the keymap and copy-paste the output where needed.
                </p>
                <p class="lead">
                    You can also send direct facebook message to <a href="http://m.me/sadakhata.chat" target="_blank"><b>Sadakhata chat bot</b></a>, you'll get instant reply with converted Bangla text.
                </p>
            </div>
        </Main>
    </div>
</template>

<script>
// @ is an alias to /src
import Topbar from '../components/Topbar';
import Main from '../components/Main';

export default {
    name: 'home',
    components: {
        Main,
        Topbar
    },
    mounted () {
        this.$store.commit('app/SET_PAGE_TITLE', 'Sadakhata');
    }
};
</script>
